module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kc-Lb.a2ab0b0d.png";